import React from 'react';
import styled from 'styled-components'
import { SkeletonCircle, SkeletonLine } from './skeleton'

const StatsBar = (props) => {

    const loading = props.loading || !props.data;
    const datasets = props.data?.datasets || [];

    // Find the target line dataset
    const targetDs = datasets.find(ds => !ds.stageKey && ds.type === 'line');
    const sumTarget = targetDs ? targetDs.data.reduce((acc, v) => acc + (v || 0), 0) : 0;

    // Find closed won dataset by stageKey
    const wonDs = datasets.find(ds => ds.stageKey === 'closedwon');
    const sumWon = wonDs ? wonDs.data.reduce((acc, v) => acc + (v || 0), 0) : 0;

    // Open is sum of all bar datasets except closedwon
    let open = 0;
    datasets.forEach(ds => {
        if (ds.stageKey && ds.stageKey !== 'closedwon') {
            open += ds.data.reduce((acc, v) => acc + (v || 0), 0);
        }
    });
    const gap = sumTarget - sumWon - open;

    // format currency $ no decimal places, no currency country code
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
      });

      const formatDollars = (dollars) => {
        return formatter.format(dollars);
      }

    const cards = [
        { key: 'target', title: 'TARGET', value: sumTarget, note: 'FY total', icon: '🎯', fg: '#475569', bg: '#EEEEEE' },
        { key: 'won', title: 'WON', value: sumWon, note: 'FY total', icon: '🏆', fg: '#2E7D32', bg: '#EEF7F0' },
        { key: 'open', title: 'OPEN', value: open, note: 'FY total', icon: '📂', fg: '#0E7490', bg: '#E8F6FB' },
        { key: 'gap', title: 'GAP', value: gap, note: 'to target', icon: 'Δ', fg: '#475569', bg: '#F1F3F5' },
    ];

    return (
        <Container>
            {cards.map(c => (
                <StatCard key={c.key}>
                    <Left>
                        {loading ? (
                            <>
                                <SkeletonLine $w="80px" $h="14px" />
                                <SkeletonLine $w="120px" $h="24px" style={{ marginTop: 8, marginBottom: 6 }} />
                                <SkeletonLine $w="60px" $h="12px" />
                            </>
                        ) : (
                            <>
                                <Title>{c.title}</Title>
                                <Figure>{formatDollars(c.value)}</Figure>
                                <Subtle>{c.note}</Subtle>
                            </>
                        )}
                    </Left>
                    <Right>
                        {loading ? (
                            <SkeletonCircle $w="56px" $h="56px" />
                        ) : (
                            <IconCircle style={{ color: c.fg, backgroundColor: c.bg }}>{c.icon}</IconCircle>
                        )}
                    </Right>
                </StatCard>
            ))}
        </Container>
    )
}

export default StatsBar;

const Container = styled.div`
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    column-gap: 20px;
    margin-bottom: 20px;
    margin-top: 40px;
    @media (max-width: 768px) {
        flex-wrap: wrap;
        row-gap: 16px;
    }
`;


const Title = styled.h2`
    font-size: 0.85rem;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #8A94A6;
    margin: 0;
`;

const Figure = styled.p`
    font-size: 1.8rem;
    color: #0b1220;
    margin: 2px 0 4px 0;
`;
const Subtle = styled.p`
    font-size: 0.8rem;
    color: #8A94A6;
    margin: 0;
`;
const StatCard = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 20px;
    border-radius: 12px;
    background: rgba(255,255,255,0.75);
    border: 1px solid #e9edf3;
    box-shadow: 0 4px 14px rgba(0,0,0,0.12);
    backdrop-filter: blur(6px);
    min-height: 80px;
    @media (max-width: 768px) {
        flex-basis: calc(50% - 20px);
    }
`;

const Left = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

const Right = styled.div`
    display: flex;
    align-items: center;
`;

const IconCircle = styled.div`
    width: 56px;
    height: 56px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.6rem;
    font-weight: 700;
`;
